import AdminView from "./AdminView";
import PimpinanView from "./PimpinanView";

export default function Dashboard({ user }) {
  return (
    <div style={{ padding: "1.5rem" }}>
      {user.role === "admin" ? (
        <AdminView user={user} />
      ) : (
        <PimpinanView user={user} />
      )}
    </div>
  );
}
